// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__sq093","author":"Table_author__1OPQh","authorImage":"Table_authorImage__rlxLT","unreadRow":"Table_unreadRow__3eTIx"};